import { Link } from 'react-router-dom';
import { trackFunnelEvent } from '../../lib/funnel-tracking';

const BENEFITS = [
  '8 planetas restantes com interpretações completas',
  '12 casas astrológicas detalhadas',
  'Previsões diárias, semanais e mensais personalizadas',
  'Sinastria real entre dois mapas natais',
  'Trânsitos, progressões e exportação PDF',
];

interface Props {
  onClickUpgrade?: () => void;
  source?: string;
}

export function SoftPaywallBanner({ onClickUpgrade, source = 'mapa' }: Props) {
  function handleClick() {
    trackFunnelEvent('clicked_upgrade_cta', { location: source });
    onClickUpgrade?.();
  }

  return (
    <div style={{
      background:   'var(--bg-elevated)',
      border:       '1px solid var(--line-soft)',
      borderRadius: 'var(--radius-md)',
      padding:      '1.5rem',
    }}>
      <p style={{ fontFamily: 'var(--font-display)', fontStyle: 'italic', fontSize: 'var(--text-22)', color: 'var(--bg)', fontWeight: 400, margin: '0 0 1rem' }}>
        Desbloqueie seu universo completo ✦
      </p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', marginBottom: '1.25rem' }}>
        {BENEFITS.map(b => (
          <div key={b} style={{ display: 'flex', gap: '0.6rem', alignItems: 'flex-start' }}>
            <span style={{ color: 'var(--petrol)', flexShrink: 0, marginTop: '2px' }}>✦</span>
            <span style={{ fontSize: 'var(--text-label)', color: 'var(--text-secondary)' }}>{b}</span>
          </div>
        ))}
      </div>

      {onClickUpgrade ? (
        <button onClick={handleClick} className="btn btn-primary btn-block" style={{ marginBottom: '0.625rem' }}>
          Começar agora, R$ 24,90/mês
        </button>
      ) : (
        <Link
          to="/pricing"
          onClick={() => trackFunnelEvent('viewed_pricing', { source })}
          className="btn btn-primary btn-block"
          style={{ marginBottom: '0.625rem', display: 'block', textAlign: 'center' }}
        >
          Começar agora, R$ 24,90/mês
        </Link>
      )}

      <p style={{ textAlign: 'center', fontSize: 'var(--text-caption)', color: 'var(--text-muted)', margin: 0 }}>
        Cancele quando quiser · Garantia de 7 dias
      </p>
    </div>
  );
}
